import React from 'react'
import Select from 'react-select'

export const MultiSelect = ({ options, selectOption, value, onChange, placeholder, isMulti, styles }) => {
  const colourStyles = {
    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
            fontSize: '12px',
            marginLeft: '-4px',
            outline: 'none'
        }
    },
    control: base => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: 'none'
    })
  }

  return (
    <Select styles={ colourStyles } options={ options } selectOption={ selectOption } isMulti={ isMulti } value={ value } placeholder={ placeholder } onChange={ onChange } isSearchable={false}  />
  )
}



